export const pasteFormattedText = (element: any) => {
  element?.addEventListener('paste', (event: any) => {
    event.preventDefault()
    const text = event.clipboardData.getData('text/plain')
    document.execCommand('insertHTML', false, text)
  })
}
